/* unplugin-vue-components disabled */import { render } from "./fzsanfangqixiang.vue?vue&type=template&id=4e1506ca&scoped=true"
import script from "./fzsanfangqixiang.vue?vue&type=script&lang=js"
export * from "./fzsanfangqixiang.vue?vue&type=script&lang=js"

import "./fzsanfangqixiang.vue?vue&type=style&index=0&id=4e1506ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1506ca"]])

export default __exports__